import { render } from "./DashboardMenu.vue?vue&type=template&id=1a5bd138&scoped=true"
import script from "./DashboardMenu.vue?vue&type=script&lang=js"
export * from "./DashboardMenu.vue?vue&type=script&lang=js"

import "./DashboardMenu.vue?vue&type=style&index=0&id=1a5bd138&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a5bd138"]])

export default __exports__